import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';


class TextView extends Component{

  render(){
    return(
      <Layout {...this.props} type="TextView"/>
    )
  }
}

TextView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};
 
export default TextView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/TextView.js